import React from 'react';
import dynamic from 'next/dynamic';
import Layout from '../components/Dashboard/Layout/Dynamic';
import withApollo from '../lib/apollo';
import loading from '../lib/loading';

const JobForm = dynamic(
  () => import('../components/Jobs/JobForm'), {
    ssr: false,
    loading,
  },
);

export const JobFormPage = () => (
  <Layout layoutMaxWidth="840px">
    <JobForm />
  </Layout>
);

JobFormPage.getLayout = (page) => page;

export default withApollo(JobFormPage);
